// FinTrack — i18n (EN/SR) za dvojezične PDF dashboarde + jezik modal
// Postojeći UI ostaje SR; ovde su stringovi za PDF izvoz i izbor jezika.

const DICT = {
  // --- generic ---
  language: { en: 'Language', sr: 'Jezik' },
  choose_language: { en: 'Choose report language', sr: 'Izaberi jezik izveštaja' },
  english: { en: 'English', sr: 'Engleski' },
  serbian: { en: 'Serbian', sr: 'Srpski' },
  cancel: { en: 'Cancel', sr: 'Otkaži' },
  generated: { en: 'Generated', sr: 'Generisano' },
  page: { en: 'Page', sr: 'Strana' },
  period: { en: 'Period', sr: 'Period' },
  rate: { en: 'Rate', sr: 'Kurs' },
  total: { en: 'Total', sr: 'Ukupno' },
  amounts_in: { en: 'Amounts in', sr: 'Iznosi u' },
  days: { en: 'Days', sr: 'Dani' },
  category: { en: 'Category', sr: 'Kategorija' },
  amount: { en: 'Amount', sr: 'Iznos' },
  count: { en: 'Count', sr: 'Broj' },
  komitent: { en: 'Counterparty', sr: 'Komitent' },

  // --- weekly / liabilities dashboard ---
  liabilities_overview: { en: 'Liabilities Overview', sr: 'Pregled obaveza' },
  weekly_report: { en: 'Weekly Report', sr: 'Nedeljni izveštaj' },
  executive_summary: { en: 'Executive Summary', sr: 'Izvršni rezime' },
  key_highlights: { en: 'Key liabilities highlights', sr: 'Ključni pokazatelji obaveza' },
  total_liabilities: { en: 'Total Liabilities', sr: 'Ukupne obaveze' },
  past_due: { en: 'Past-due (Due)', sr: 'Dospelo' },
  upcoming: { en: 'Up-coming (Not yet due)', sr: 'Nedospelo (uskoro)' },
  payroll_wages: { en: 'Payroll (Wages)', sr: 'Neisplaćene zarade' },
  property_tax: { en: 'Property Tax', sr: 'Porez na imovinu' },
  composition_by_category: { en: 'Composition by category', sr: 'Struktura po kategoriji' },
  top_exposure: { en: 'Top exposure', sr: 'Najveće stavke' },
  by_outstanding: { en: 'By outstanding amount', sr: 'Po iznosu duga' },
  upcoming_maturities: { en: 'Upcoming maturities', sr: 'Predstojeća dospeća' },
  due_in_days: { en: 'Due in (days)', sr: 'Dospeva za (dana)' },
  due_date: { en: 'Due date', sr: 'Datum dospeća' },
  key_takeaways: { en: 'Key Takeaways', sr: 'Ključni nalazi' },
  of_total: { en: 'of total', sr: 'od ukupno' },
  due_now: { en: 'due now', sr: 'dospelo sada' },
  not_yet_due: { en: 'not yet due', sr: 'još nije dospelo' },
  largest_category: { en: 'Largest category', sr: 'Najveća kategorija' },
  counterparties: { en: 'Counterparties', sr: 'Broj komitenata' },
  severely_overdue: { en: 'Overdue 90+ days', sr: 'Kašnjenje 90+ dana' },
  total: { en: 'Total', sr: 'Ukupno' },
  next_maturity: { en: 'Next maturity', sr: 'Sledeće dospeće' },
  uncategorized: { en: 'Uncategorized', sr: 'Nekategorisani' },

  // --- monthly / financial dashboard ---
  monthly_report: { en: 'Monthly Report', sr: 'Mesečni izveštaj' },
  financial_overview: { en: 'Financial Overview', sr: 'Finansijski pregled' },
  cashflow: { en: 'Cash Flow', sr: 'Tok gotovine' },
  balance_sheet: { en: 'Balance Sheet', sr: 'Bilans stanja' },
  pnl: { en: 'Profit & Loss', sr: 'Bilans uspeha' },
  inventory: { en: 'Inventory', sr: 'Zalihe' },
  cash_position: { en: 'Cash position', sr: 'Stanje gotovine' },
  receivables: { en: 'Receivables', sr: 'Potraživanja' },
  payables: { en: 'Payables', sr: 'Obaveze' },
  vendor_debt_today: { en: 'Vendor debt (435+436) as of report date', sr: 'Obaveze prema dobavljačima (435+436) na dan izveštaja' },
  net_income: { en: 'Net income', sr: 'Neto dobit' },
  revenue: { en: 'Revenue', sr: 'Prihodi' },
  expenses: { en: 'Expenses', sr: 'Rashodi' },
  assets: { en: 'Assets', sr: 'Aktiva' },
  liabilities: { en: 'Liabilities', sr: 'Pasiva (obaveze)' },
  equity: { en: 'Equity', sr: 'Kapital' },
  month: { en: 'Month', sr: 'Mesec' },
  year: { en: 'Year', sr: 'Godina' },
};

export function t(key, lang) {
  const e = DICT[key];
  if (!e) return key;
  return e[lang === 'en' ? 'en' : 'sr'] || e.sr || key;
}

// Modal koji vraća Promise<'en'|'sr'|null>. Bez zavisnosti — sam pravi overlay.
export function pickLanguage(defaultLang = 'sr') {
  return new Promise(resolve => {
    const existing = document.getElementById('mdlLang');
    if (existing) existing.remove();
    const ov = document.createElement('div');
    ov.id = 'mdlLang';
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.78);z-index:1200;display:flex;align-items:center;justify-content:center;padding:16px';
    const box = document.createElement('div');
    box.style.cssText = 'background:var(--base,#11131a);border:1px solid var(--border,#2a2d3a);border-radius:14px;width:min(420px,94vw);padding:22px;text-align:center';
    const h = document.createElement('h2');
    h.style.cssText = 'font-size:17px;color:var(--acc,#c9a84c);margin-bottom:6px';
    h.textContent = t('choose_language', defaultLang) + ' / ' + t('choose_language', defaultLang === 'sr' ? 'en' : 'sr');
    const sub = document.createElement('div');
    sub.style.cssText = 'font-size:12px;color:var(--tx3,#8a8ea0);margin-bottom:18px';
    sub.textContent = 'PDF → ' + t('language', 'sr') + ' / ' + t('language', 'en');
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:12px;justify-content:center';
    const mk = (lang, label, flag) => {
      const b = document.createElement('button');
      b.style.cssText = 'flex:1;padding:16px 12px;border-radius:10px;border:1px solid var(--border,#2a2d3a);background:var(--surface,#1a1d28);color:var(--tx,#e6e8f0);font-size:15px;font-weight:600;cursor:pointer;transition:.15s';
      b.onmouseenter = () => { b.style.borderColor = 'var(--acc,#c9a84c)'; b.style.background = 'var(--hover,#222533)'; };
      b.onmouseleave = () => { b.style.borderColor = 'var(--border,#2a2d3a)'; b.style.background = 'var(--surface,#1a1d28)'; };
      b.innerHTML = '<div style="font-size:26px;margin-bottom:6px">' + flag + '</div>' + label;
      b.onclick = () => { ov.remove(); resolve(lang); };
      return b;
    };
    row.appendChild(mk('sr', t('serbian', 'sr'), '🇷🇸'));
    row.appendChild(mk('en', t('english', 'en'), '🇬🇧'));
    const cancel = document.createElement('button');
    cancel.style.cssText = 'margin-top:16px;background:transparent;border:none;color:var(--tx3,#8a8ea0);font-size:13px;cursor:pointer';
    cancel.textContent = t('cancel', defaultLang);
    cancel.onclick = () => { ov.remove(); resolve(null); };
    box.appendChild(h); box.appendChild(sub); box.appendChild(row); box.appendChild(cancel);
    ov.appendChild(box);
    ov.addEventListener('click', e => { if (e.target === ov) { ov.remove(); resolve(null); } });
    document.body.appendChild(ov);
  });
}
